import { Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function LoadsHeader() {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold">Kuormat</h1>
        <p className="text-muted-foreground">Hallitse asennuskuormia ja reittejä</p>
      </div>
      <Link to="/loads/create">
        <Button className="gap-2">
          <Plus className="h-4 w-4" />
          Luo uusi kuorma
        </Button>
      </Link>
    </div>
  );
}
